// extracted by mini-css-extract-plugin
module.exports = {"jds-ModalLink":"modalLink_jds-ModalLink__zJxsO","jds-ModalLink--selected":"modalLink_jds-ModalLink--selected__pzBUW"};